/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Body_Assessment_Consent_RevokeInputs */

const en_us2_body_assessment_consent_revoke = /** @type {(inputs: Body_Assessment_Consent_RevokeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Withdraw permission`)
};

const pt_br2_body_assessment_consent_revoke = /** @type {(inputs: Body_Assessment_Consent_RevokeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Revogar autorização`)
};

const es_419_body_assessment_consent_revoke = /** @type {(inputs: Body_Assessment_Consent_RevokeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Retirar permiso`)
};

const pt_pt2_body_assessment_consent_revoke = /** @type {(inputs: Body_Assessment_Consent_RevokeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Revogar autorização`)
};

const fr_fr2_body_assessment_consent_revoke = /** @type {(inputs: Body_Assessment_Consent_RevokeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Retirer l'autorisation`)
};

const de_de2_body_assessment_consent_revoke = /** @type {(inputs: Body_Assessment_Consent_RevokeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erlaubnis widerrufen`)
};

const it_it2_body_assessment_consent_revoke = /** @type {(inputs: Body_Assessment_Consent_RevokeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Revoca il consenso`)
};

/**
* | output |
* | --- |
* | "Withdraw permission" |
*
* @param {Body_Assessment_Consent_RevokeInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const body_assessment_consent_revoke = /** @type {((inputs?: Body_Assessment_Consent_RevokeInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Body_Assessment_Consent_RevokeInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_body_assessment_consent_revoke(inputs)
	if (locale === "es-419") return es_419_body_assessment_consent_revoke(inputs)
	if (locale === "pt-PT") return pt_pt2_body_assessment_consent_revoke(inputs)
	if (locale === "fr-FR") return fr_fr2_body_assessment_consent_revoke(inputs)
	if (locale === "de-DE") return de_de2_body_assessment_consent_revoke(inputs)
	if (locale === "it-IT") return it_it2_body_assessment_consent_revoke(inputs)
	return en_us2_body_assessment_consent_revoke(inputs)
});
export { body_assessment_consent_revoke as "body-assessment.consent_revoke" }